import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsInputs from './enpoints'

const ConventionsService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsInputs.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsInputs.LOAD_BY_ID(id)),
  create: async (body) => POST(endpointsInputs.CREATE, body),
  update: async ({ _id, body }) => PATCH(endpointsInputs.LOAD_BY_ID(_id), body),
  remove: async (id) => DELETE(endpointsInputs.LOAD_BY_ID(id)),
}

export default ConventionsService
